import { SplashScreen } from '@capacitor/splash-screen'
import { setUserPref } from '@eventr/common'
import {
    MainButton,
    MobileConfirmDialog,
    TDialogStore,
    useDialogStore,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import * as Sentry from '@sentry/react'
import { useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { defaultAddSnack } from '../../state/overlayState/overlayContext'
import { userPrefShowDevOverlay } from '../../state/userPrefsState/userPrefsSignels'
import { NavigationView } from '../layout/NavigationView'
import { ds, useDevStore } from './devSettings.slice'

export const DevMenuPage = () => {
    const nav = useNavigate()

    const { isImpersonateOn } = useDevStore(
        useShallow((s) => {
            return { isImpersonateOn: s.isImpersonateOn }
        })
    )
    const { replaceDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({ replaceDialog: s.replaceDialog }))
    )
    return (
        <Box paddingTop={'10px'}>
            <NavigationView
                navigationBarTitle="Dev Menu"
                backButtonAction={() => {
                    nav(-1)
                }}
                usePageTransition
            >
                <Stack padding={'20px'} spacing={'10px'}>
                    <MainButton
                        onClick={() => {
                            nav('/devMenu/logs')
                        }}
                    >
                        Logs
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            nav('/devMenu/time')
                        }}
                    >
                        Time settings
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            nav('/devMenu/env')
                        }}
                    >
                        Env settings
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            nav('/devMenu/store')
                        }}
                    >
                        Store
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            Sentry.captureMessage('Something went wrong', {})
                        }}
                    >
                        Send logs
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            throw new Error('Force crash')
                        }}
                    >
                        Force crash
                    </MainButton>
                    <MainButton
                        onClick={() => {
                            SplashScreen.show({
                                autoHide: true,
                                fadeOutDuration: 1000,
                            })
                        }}
                    >
                        Open splash screen for 1 sec.
                    </MainButton>
                    <Box display={'grid'} gridAutoFlow={'column'}>
                        <MainButton
                            onClick={() => {
                                userPrefShowDevOverlay.value = 'dev'
                                setUserPref('account', 'showDevOverlay', 'dev')
                            }}
                        >
                            Use DEV Overlay
                        </MainButton>
                        <MainButton
                            onClick={() => {
                                userPrefShowDevOverlay.value = 'prod'
                                setUserPref('account', 'showDevOverlay', 'prod')
                            }}
                        >
                            DONT Use DEV Overlay
                        </MainButton>
                    </Box>
                    <MainButton
                        text="Add error snack"
                        onClick={() => {
                            defaultAddSnack('new snack', 'error')
                        }}
                    />
                    <MainButton
                        text="open dialog"
                        onClick={() => {
                            replaceDialog({
                                node: <MobileConfirmDialog text="asdfasdf" />,
                                backdropClosable: true,
                            })
                        }}
                    />
                    <MainButton
                        text={
                            isImpersonateOn
                                ? 'Turn Impersonate Off'
                                : 'Turn Impersonate On'
                        }
                        onClick={() => {
                            ds().setImpersonateOn(!isImpersonateOn)
                        }}
                    />
                </Stack>
            </NavigationView>
        </Box>
    )
}
